<div class="banner" role="banner" [ngStyle]="{ 'background-image': 'url(' + ('images/banner-background.jpg' | contentAssetImage) + ')' }">
  <div class="container d-flex align-items-center">
    <h1 class="font-page-heading title fw-light-bold">{{ title }}</h1>
  </div>
</div>



